"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ImageModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const validate_js_1 = require("validate.js");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
const form_2 = require("../_components/form");
const Image_contracts_1 = require("./Image.contracts");
/**
 * Component that contains a complete questionnaire needed to **EDIT** the `Image`'s contents.
 *
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ImageModuleForm = ImageModuleForm_1 = class ImageModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        this.moduleModes = _contracts_1.ModuleMode;
        this.variants = Image_contracts_1.ImageSelectionOptions;
        this.hasExternalLink = false;
        /**
         * The image to render.
         */
        this.img = null;
        /**
         * The image caption to show.
         */
        this.imgCaption = '';
        /**
         * For smart pages enable option to select linked or find another
         */
        this.variant = Image_contracts_1.ImageSelectionOptions.Default;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = ImageModuleForm_1.getInitialContent();
    }
    get hasRelatedLink() {
        return !!(this._content.redirect && typeof this._content.redirect !== 'string' &&
            typeof this._content.redirect.value !== 'undefined' && typeof this._content.redirect.type !== 'undefined');
    }
    get options() {
        const options = [
            {
                label: `${this.$t('forms.shared.selectionModes.default')}`,
                value: Image_contracts_1.ImageSelectionOptions.Default
            },
            {
                label: `${this.$t('forms.shared.selectionModes.auto')}`,
                value: Image_contracts_1.ImageSelectionOptions.Smart
            }
        ];
        return options;
    }
    get urlPath() {
        if (!this._content.redirectExt || typeof this._content.redirectExt !== 'string') {
            return '';
        }
        return this._content.redirectExt;
    }
    set urlPath(value) {
        const contentCopy = { ...this._content };
        contentCopy.redirectExt = value;
        this._content = contentCopy;
    }
    changeImageVariant(value) {
        this.variant = value;
        if (value === Image_contracts_1.ImageSelectionOptions.Smart) {
            this._content.image = {
                type: services_1.RelatedType.File,
                value: '##IMAGE_ID##'
            };
            this._content.imageType = Image_contracts_1.ImageSelectionOptions.Smart;
        }
        else {
            this._content.image = {};
            this._content.imageType = Image_contracts_1.ImageSelectionOptions.Default;
        }
    }
    deleteLinkSource() {
        if (!this._content.redirect) {
            return;
        }
        const contentCopy = { ...this._content };
        delete contentCopy.redirect;
        this._content = contentCopy;
    }
    /**
     * Check that image is define
     */
    hasImage() {
        return !!this._content.image && typeof this._content.image.value !== 'undefined';
    }
    /**
     * Get image source form picker
     */
    findImageSource() {
        this.pickRelated(services_1.Picker.Media, this.setImageSource);
    }
    /**
     * Get link source form picker
     */
    findLinkSource() {
        this.pickRelated(services_1.Picker.Content, this.setLinkSource);
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Image,
            size: {
                colSpan: 2,
                rowSpan: 2,
                isResizable: true,
                minColSpan: 1,
                minRowSpan: 1,
                maxColSpan: 6
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            action: Image_contracts_1.FileDataActions.None,
            image: {},
            imageType: Image_contracts_1.ImageSelectionOptions.Default,
            useAsAd: false,
            hideDescription: false,
            hideAuthor: false
        };
    }
    /**
     * Get image to render from related services
     */
    findImageRelated() {
        if (typeof this._content.image === 'undefined' || !this.hasImage()) {
            return;
        }
        const related = this.relatedService.resolve(this._content.image, {});
        if (!validate_js_1.isPromise(related)) {
            return;
        }
        related.then((related) => {
            if (Object.prototype.hasOwnProperty.call(related, 'caption')) {
                this.imgCaption = related.caption;
            }
            if (Object.prototype.hasOwnProperty.call(related, 'file')) {
                this.img = {
                    type: related.file.type,
                    thumbnail: related.url
                };
            }
            else if (Object.prototype.hasOwnProperty.call(related, 'url')) {
                this.img = {
                    type: backoffice_1.ImageType.JPG,
                    thumbnail: related.url
                };
            }
        }).catch(error => {
            console.debug(error);
        });
    }
    onHasExternalLinkChange(value) {
        this.hasExternalLink = value;
        if (value) {
            if (this._content.redirect) {
                const contentCopy = { ...this._content };
                delete contentCopy.redirect;
                this._content = contentCopy;
            }
        }
        else {
            if (this._content.redirectExt && typeof this._content.redirectExt === 'string') {
                const contentCopy = { ...this._content };
                delete contentCopy.redirectExt;
                this._content = contentCopy;
            }
        }
    }
    /**
     * Set image selected form picker
     */
    setImageSource(source) {
        this._content.image = source;
        this._content.imageType = Image_contracts_1.ImageSelectionOptions.Default;
        this.$nextTick(() => {
            this.findImageRelated();
        });
    }
    /**
     * Set redirect selected form picker
     */
    setLinkSource(source) {
        if (this._content.redirect) {
            this._content.redirect = source;
        }
        else {
            this._content = {
                ...this._content,
                redirect: source
            };
        }
        this.$nextTick(() => {
            this.describe(source);
        });
    }
    setActiveVariant(related) {
        switch (related.value) {
            case '##IMAGE_ID##':
                this.variant = Image_contracts_1.ImageSelectionOptions.Smart;
                break;
            case -1:
                this.variant = Image_contracts_1.ImageSelectionOptions.Smart;
                break;
            default:
                this.variant = Image_contracts_1.ImageSelectionOptions.Default;
        }
    }
};
__decorate([
    vue_property_decorator_1.Watch('hasExternalLink', { deep: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ImageModuleForm.prototype, "onHasExternalLinkChange", null);
ImageModuleForm = ImageModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'ImageModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixFile: backoffice_1.DashmixFile,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixSelect: backoffice_1.DashmixSelect,
            FormErrors: form_2.FormErrors
        },
        mounted() {
            /**
             * Legacy support for
             */
            if (typeof this._content.useAsAd === 'undefined') {
                this._content.useAsAd = false;
            }
            if (typeof this._content.hideDescription === 'undefined') {
                this._content.hideDescription = false;
            }
            if (typeof this._content.hideAuthor === 'undefined') {
                this._content.hideAuthor = false;
            }
            /**
             * EOF Legacy support for
             */
            if (this._content.image) {
                this.setActiveVariant(this._content.image);
            }
            if (this._content.imageType === this.variants.Smart && this.mode === this.moduleModes.Smart) {
                return;
            }
            this.hasExternalLink = !!(this._content.redirectExt && typeof this._content.redirectExt === 'string');
            this.$nextTick(() => {
                this.findImageRelated();
                if (this._content.redirect) {
                    this.describe(this._content.redirect);
                }
            });
        },
        template: `
    <div>
    <div class="row">
      <div class="col-4" v-if="mode === moduleModes.Smart">
        <DashmixSelect :model="variant" @update:model="changeImageVariant" :options="options"/>
      </div>
      <div class="col" v-if="variant === variants.Default">
        <DashmixButton variant="alt" :icon="icons.SearchSolid" :label="$t('forms.shared.search')"
                       @click="findImageSource"/>
      </div>
    </div>

    <div v-if="hasImage() && (this._content.imageType === variants.Default || this.mode === moduleModes.Default)"
         class="row pt-3">
      <div v-if="img" class="col-6">
        <p class="mb-3"><b>{{ $t('forms.image.selected') }}</b></p>
        <figure class="image-form__figure">
          <DashmixFile class="mb-3" :file="img"/>
          <figcaption>{{ imgCaption }}</figcaption>
        </figure>
      </div>

      <div class="col-6">
        <DashmixCheck class="pb-3" :label="$t('forms.image.hideAuthor')" name="hideAuthor"
                      :model.sync="_content.hideAuthor"/>
        <DashmixCheck class="pb-3" :label="$t('forms.image.hideDescription')" name="hideDescription"
                      :model.sync="_content.hideDescription"/>
        <DashmixCheck class="pb-3" :label="$t('forms.image.useAsAd')" name="useAsAd"
                      :model.sync="_content.useAsAd"/>
        <DashmixCheck class="pb-3" :label="$t('forms.image.hasExternalLink')" name="hasExternalLink"
                      :model.sync="hasExternalLink"/>

        <template v-if="!hasExternalLink">
          <DashmixButton v-if="!hasRelatedLink" variant="alt" :icon="icons.SearchSolid"
                         :label="$t('forms.shared.search')"
                         @click="findLinkSource"/>

          <div class="row" v-else>
            <div class="col d-flex align-items-center">
              <p class="mb-0">
                <strong class="mr-2">{{ $t('forms.shared.chosenSource') }}</strong>
                {{ description(_content.redirect) }}
              </p>
            </div>
            <div class="col-3 d-flex text-right">
              <DashmixButton variant="icon" :icon="icons.PenSolid"
                             @click="findLinkSource"/>
              <DashmixButton theme="danger" variant="icon"
                             :icon="icons.TrashSolid"
                             @click="deleteLinkSource"/>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="form-group">
            <label for="urlPath" class="d-block">{{ $t('forms.image.path.label') }}</label>
            <DashmixInput :model.sync="urlPath" name="urlPath"
                          :placeholder="$t('forms.image.path.placeholder')"/>
          </div>
        </template>
        <div>
        </div>
      </div>
    </div>
    <!-- Form errors -->
    <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3"/>
    </div>`
    })
], ImageModuleForm);
exports.ImageModuleForm = ImageModuleForm;
//# sourceMappingURL=Image.form.js.map